import { Fragment, h } from '@atomify/jsx';
import { Button, ButtonVariant } from '@atoms/button/button';

const ContentCollapseContent = (data: {
    name: string;
    expanded?: boolean;
    children?: NodeList;
}) => (
    <bpd-content-collapse
        id={`${data.name}-controls`}
        name={data.name}
        aria-labelledby={`${data.name}-labelledby`}
        aria-hidden={!data.expanded}
        {...{
            expanded: data.expanded,
        }}>
        {data.children}
    </bpd-content-collapse>
);

const ContentCollapseButton = (data: {
    name: string;
    buttonVariant?: ButtonVariant | null;
    expanded?: boolean;
    useButtonComponent?: boolean;
    expandedLabel: string;
    collapsedLabel: string;
    classes?: string;
}) => {
    const attributes = {
        id: `${data.name}-labelledby`,
        'aria-controls': `${data.name}-controls`,
        'aria-expanded': `${data.expanded ? 'true' : 'false'}`,
        'data-collapsed-label': data.collapsedLabel,
        'data-expanded-label': data.expandedLabel,
        type: 'button',
    };

    return (
        <Fragment>
            {data.useButtonComponent ? (
                <Button
                    label=""
                    variant={data.buttonVariant}
                    classes={data.classes}
                    attr={attributes}>
                    <span js-hook-content-collapse-label>
                        {data.expanded ? data.expandedLabel : data.collapsedLabel}
                    </span>
                </Button>
            ) : (
                <button class={data.classes} {...attributes}>
                    {data.expanded ? data.expandedLabel : data.collapsedLabel}
                </button>
            )}
        </Fragment>
    );
};

export { ContentCollapseContent, ContentCollapseButton };
